var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-share-sheet',{attrs:{"title":_vm.question.fileName,"options":_vm.moreList},on:{"select":_vm.onSelect},model:{value:(_vm.morePopupShow),callback:function ($$v) {_vm.morePopupShow=$$v},expression:"morePopupShow"}}),_c('statusPopup',{ref:"statusPopup",on:{"callback":_vm.refresh}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }